import React from "react";
import SectionHeader from "./SectionHeader";
import { certifications } from "../mock";
import * as Icons from "lucide-react";

const Certs = () => {
  return (
    <section id="certs" className="relative px-6 lg:px-10 py-20 border-t border-[#1c2533]">
      <div className="max-w-7xl mx-auto">
        <SectionHeader
          num="07 // CREDENTIALS"
          title="CERTIFICATIONS"
          subtitle="VERIFIED // INDUSTRY-RECOGNIZED"
        />

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-3">
          {certifications.map((c, i) => {
            const Ico = Icons[c.icon] || Icons.Award;
            const done = c.state === "done";
            return (
              <div
                key={i}
                className="border border-[#1c2533] bg-[#0c1118] p-5 card-hover flex flex-col"
              >
                <div className="flex items-start justify-between mb-4">
                  <div
                    className={`w-11 h-11 grid place-items-center border ${
                      done ? "border-emerald-400/50 text-emerald-400" : "border-amber-400/50 text-amber-400"
                    }`}
                  >
                    <Ico size={20} strokeWidth={1.5} />
                  </div>
                  <span
                    className={`status-badge ${
                      done
                        ? "border-emerald-400/40 text-emerald-400 bg-emerald-400/5"
                        : "border-amber-400/40 text-amber-400 bg-amber-400/5"
                    }`}
                  >
                    {done ? "\u2713" : "\u26a1"} {c.status}
                  </span>
                </div>
                <h4 className="font-mono font-semibold text-[14px] leading-snug text-slate-100 mb-2">
                  {c.name}
                </h4>
                <div className="font-mono text-[10.5px] tracking-[0.18em] text-slate-500 mt-auto pt-3 border-t border-[#1c2533]">
                  {c.issuer}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Certs;
